export default __webpack_public_path__ + "static/media/logo3.4499d998.png";